import { EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var DeleteModalComponent = (function () {
    function DeleteModalComponent(modalService) {
        this.modalService = modalService;
        this.type = '';
        this.confirm = 'ยืนยันการลบ';
        this.cancel = 'ยกเลิก';
        this.titleText = 'ยืนยันการลบ';
        this.textDeleteConfirm = 'ยืนยันอีกครั้งเพื่อทำการลบ';
        this.deleteMessage = 'ลบ';
        this.disabledButton = false;
        this.submitted = new EventEmitter();
    }
    DeleteModalComponent.prototype.ngOnInit = function () {
    };
    DeleteModalComponent.prototype.open = function (content) {
        this.modal = this.modalService.open(content);
    };
    DeleteModalComponent.prototype.submit = function () {
        this.submitted.emit();
        this.modal.close();
    };
    return DeleteModalComponent;
}());
export { DeleteModalComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/delete-modal/delete-modal.component.ts.pre-build-optimizer.js